/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_List_Created_SuccessInputs */

const en_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New list created successfully`)
};

const fr_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle liste créée avec succès`)
};

const de_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Liste erfolgreich erstellt`)
};

const it_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo elenco creato con successo`)
};

const ru_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый список успешно создан.`)
};

const es_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva lista creada exitosamente`)
};

const zh_cn2_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新列表已成功创建`)
};

const ja_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいリストが正常に作成されました`)
};

const hi_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई सूची सफलतापूर्वक बनाई गई`)
};

const pt_pt2_new_list_created_success = /** @type {(inputs: New_List_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova lista criada com sucesso`)
};

/**
* | output |
* | --- |
* | "New list created successfully" |
*
* @param {New_List_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_list_created_success = /** @type {((inputs?: New_List_Created_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_List_Created_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_list_created_success(inputs)
	if (locale === "de") return de_new_list_created_success(inputs)
	if (locale === "it") return it_new_list_created_success(inputs)
	if (locale === "ru") return ru_new_list_created_success(inputs)
	if (locale === "es") return es_new_list_created_success(inputs)
	if (locale === "zh-CN") return zh_cn2_new_list_created_success(inputs)
	if (locale === "ja") return ja_new_list_created_success(inputs)
	if (locale === "hi") return hi_new_list_created_success(inputs)
	if (locale === "pt-PT") return pt_pt2_new_list_created_success(inputs)
	return en_new_list_created_success(inputs)
});